// extracted by mini-css-extract-plugin
export default {"checkbox-list":"checkbox-list--YMAjG","checkboxList":"checkbox-list--YMAjG"};